export type WithSubComponents<C extends object, Others extends Record<string, any>> = C & Others
export function withSubComponents<C extends object, Others extends Record<string, any>>(
  base: C,
  others: Others,
): WithSubComponents<C, Others> {
  return Object.assign(base, others)
}
